export default __webpack_public_path__ + "static/media/NotoSansKR-Light.03d91ea3.woff";